import React, { useEffect, useRef, useState } from "react";

import { Calender } from "../../../arrow/components/Svgs/calender-icon";
import { DownArrow } from "../../../arrow/components/Svgs/down-arrow";
import { UpArrow } from "../../../arrow/components/Svgs/up-arrow";
import { getMagazinesInRange } from "../../../../api/utils";
import { SvgIconHandler } from "../SvgIconHandler";
import { SolidArrow } from "../../../arrow/components/Svgs/solid-arrow";
import { isLeapYear } from "../../../arrow/utils/utils";
import { MONTHS, STATIC_KEYWORDS } from "../../../constants";
import { useDeviceType } from "../../customHooks/useDeviceType";

import "./dropdown.m.css";

export const Dropdown = ({ collection, onSelect }) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [selectedMonth, setSelectedMonth] = useState("ALL");
  const [selectedYear, setSelectedYear] = useState(2025);
  const [magazines, setMagazines] = useState(collection);

  const months = ["ALL", ...MONTHS].map((m) => m.toUpperCase()).map((m) => m.slice(0, 3));

  const toggleDropdown = () => setDropdownOpen(!isDropdownOpen);
  const handleClose = () => setDropdownOpen(false);
  const handleMonthClick = (month) => setSelectedMonth(month);

  const DAYS_IN_MONTH = {
    ALL: 31,
    JAN: 31,
    FEB: isLeapYear(selectedYear) ? 29 : 28,
    MAR: 31,
    APR: 30,
    MAY: 31,
    JUN: 30,
    JUL: 31,
    AUG: 31,
    SEP: 30,
    OCT: 31,
    NOV: 30,
    DEC: 31,
  };
  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";
  const dropdownRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, [isDropdownOpen]);

  useEffect(() => {
    const fetchMagazineIssues = async () => {
      const monthIndex = months.findIndex((m) => m === selectedMonth);
      const lastDay = DAYS_IN_MONTH[months[monthIndex]];
      let from = new Date(`${monthIndex}/01/${selectedYear}`).getTime();
      let to = new Date(`${monthIndex}/${lastDay}/${selectedYear}`).getTime();
      if (monthIndex === 0) {
        from = new Date(`01/01/${selectedYear}`).getTime();
        to = new Date(`12/${lastDay}/${selectedYear}`).getTime();
      }
      const magazineIssues = await getMagazinesInRange(from, to);
      setMagazines(magazineIssues?.data);
    };
    fetchMagazineIssues();
  }, [selectedMonth, selectedYear]);

  const onSave = () => {
    onSelect(magazines);
    setDropdownOpen(false);
  };

  const { SELECT_YEAR_AND_MONTHS } = STATIC_KEYWORDS;

  return (
    <div ref={isDesktop ? dropdownRef : null} styleName="dropdown-wrapper">
      <button styleName="dropdown-button" onClick={toggleDropdown}>
        <Calender />
        <span styleName="select-edition-label">Select Edition</span>
        {isDropdownOpen ? <UpArrow /> : <DownArrow />}
      </button>
      {isDropdownOpen && (
        <div styleName={`dropdown-card ${isDesktop ? "" : "show"}`}>
          <div ref={isDesktop ? null : dropdownRef} styleName="card-content">
            <div styleName="header">
              <h3>{SELECT_YEAR_AND_MONTHS}</h3>
              <button onClick={handleClose}>
                <SvgIconHandler type={"close"} width="18" height="18" />
              </button>
            </div>
            <div styleName="divider"></div>
            <div styleName="year-dropdown">
              <button onClick={() => setSelectedYear((year) => year - 1)} styleName="left-arrow">
                <UpArrow />
              </button>
              <span styleName="year">{selectedYear}</span>
              <button onClick={() => setSelectedYear((year) => year + 1)} styleName="right-arrow">
                <UpArrow />
              </button>
            </div>
            <span styleName="selected-year">{selectedYear}</span>
            <div styleName="month-grid">
              {months.map((month) => (
                <button
                  key={month}
                  styleName={`month-button ${selectedMonth === month ? "active" : ""}`}
                  onClick={() => handleMonthClick(month)}
                >
                  {month}
                </button>
              ))}
            </div>
            <button onClick={onSave} styleName="save-button">
              Save
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
